import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnChanges,
    SimpleChanges,
} from '@angular/core';
import { Faq } from '@generated/graphql';
import { FAQPage, WithContext } from 'schema-dts';
import { FaqContentfulItemComponent } from '../faq-contentful-item/faq-contentful-item.component';

@Component({
    selector: 'app-faq-contentful-list',
    templateUrl: './faq-contentful-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FaqContentfulItemComponent],
})
export class FaqContentfulListComponent implements OnChanges {
    @Input() faqs: Faq[] = [];
    @Input() additionalClasses: string[] = [];
    seoFAQ: WithContext<FAQPage>;
    sanitizedFaqs: Faq[];

    constructor() {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.faqs) {
            this.sanitizedFaqs = this.faqs?.filter(faq => !!faq?.sys?.id) || [];
        }
    }

    trackById(index, faq: Faq) {
        return faq?.sys?.id;
    }
}
